import React, { useState } from 'react';
import styled from "styled-components";
import { NavLink } from "react-router-dom"; 
import { HashLink } from 'react-router-hash-link';
import { borderRadiusMap } from '../config';


const ItemOuter = styled.div `
  position: relative;
  display:flex;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
`;


const ItemHeading = styled.div `
    a.active  {
        color: ${({content}) => content.highlightColor};
        font-weight: bold;
    }
    a { color: ${({content}) => content.titleTextColor};}
    
`;


const SubItems = styled.div `
  background: ${({content}) => content.titleBgColor};
  border: 1px solid ${({content}) => content.titleTextColor};
  border-radius: ${({content}) => borderRadiusMap[content.roundTextBoxEdges]};
  position:absolute;
  word-break: break-word;
  width: max-content;
  max-width: 300px;
  top: ${({content}) => content.type === 'Vertical' ? '10%' : '100%'};
  left: ${({content}) => content.type === 'Vertical' ? '100%' : null};
  right: ${({content}) => content.type === 'Horizontal' ? '0vh' : null};
  z-index: 10;
`;


const SubItemStyle = styled.div `
  display:flex;
  align-items:stretch;
  padding:10px;
  border: 1px dotted ${({content}) => content};
  a { color: ${({content}) => content};}
`;

const SubItem = ({styles, subTitle, link}) => {
  const [highlight, setHighlight] = useState(false);

  const colors = {true: styles.highlightColor, false: styles.titleTextColor};

  return (
    <SubItemStyle content={colors[highlight]} onMouseOver={() => setHighlight(true)} onMouseOut={() => setHighlight(false)} onClick={() => setHighlight(false)}>
      <HashLink to={link} style={{'width': '100%'}}>{subTitle}</HashLink>
    </SubItemStyle>
  )
}

const MenuItem = ({item, page, styles, type}) => {
  const [isActive, setIsActive] = useState(false);
  const sectionTitles = (isActive && 'sections' in page) ? page.sections.filter((item) => {return item.title && item.title.length > 0}) : [];

  return (
    <ItemOuter onMouseOver={() => setIsActive(true)} onMouseOut={() => setIsActive(false)} onClick={() => setIsActive(false)}> 
      <ItemHeading content={styles}>
        <NavLink key={item} to={item}>{page.title}</NavLink>
      </ItemHeading>

      { sectionTitles.length > 0 ?
          <SubItems content={{...styles, type: type}}>
          {sectionTitles.map((localItem, index) => {
              return <SubItem key={page.title + localItem.title + index} styles={styles} subTitle={localItem.title} link={item + '/#' + localItem.title} />
            })}
          </SubItems>
        : null}

    </ItemOuter>
  );
};

export default MenuItem;